module.exports = __webpack_public_path__ + "img/society-zenobia-avatar.b0705c23.png";